import gql from 'graphql-tag';

export const ContentPropertiesQuery = gql`
	query ContentPropertiesQuery($contentId: ID, $versionOverride: Int) {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				id
				type
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;

export const ContentPropertiesQueryWithBodyRepresentation = gql`
	query ContentPropertiesQuery($contentId: ID, $versionOverride: Int) {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				id
				type
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				operations {
					operation
					targetType
				}
				body {
					dynamic {
						representation
					}
				}
				metadata {
					frontend {
						fabricEditorSupported
					}
				}
			}
		}
	}
`;
